export default __webpack_public_path__ + "static/media/thumbnail.c368be81.png";